"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.recedeGentle = exports.recedeFierce = exports.prefersReducedMotion = exports.durationShort = exports.durationMedium = exports.advanceGentle = exports.advanceFierce = void 0;
var _styledComponents = require("../../styled-components.js");
/* Transition durations */
var durationShort = exports.durationShort = '100ms';
var durationMedium = exports.durationMedium = '200ms';

/* Transition timing functions */
var advanceGentle = exports.advanceGentle = 'cubic-bezier(0.3, 0, 0.4, 1)';
var advanceFierce = exports.advanceFierce = 'cubic-bezier(0, 0, 0, 1)';
var recedeGentle = exports.recedeGentle = 'cubic-bezier(0.6, 0, 0.7, 1)';
var recedeFierce = exports.recedeFierce = 'cubic-bezier(1, 0, 1, 1)';
var prefersReducedMotion = exports.prefersReducedMotion = (0, _styledComponents.css)(["@media (prefers-reduced-motion){transition-duration:0s;}"]);